interface Props {
  width?: string;
  height?: string;
  stroke?: string;
  className: string;
};

const Metrics = ({
  stroke = '#1a1818',
  width = '48',
  height = '48',
  className,
}: Props) => (
  <svg
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <path
      d="M6.342 7.933a1.583 1.583 0 110-3.166 1.583 1.583 0 010 3.166zm3.908-.927a.572.572 0 00.32-.485v-.359a.567.567 0 00-.321-.482l-.618-.257c-.177-.074-.338-.178-.358-.232a1.096 1.096 0 01.048-.514l.25-.621a.574.574 0 00-.116-.57L9.2 3.234a.566.566 0 00-.568-.113l-.612.251c-.178.073-.366.114-.42.09a1.088 1.088 0 01-.333-.399l-.262-.612a.573.573 0 00-.485-.32h-.358a.567.567 0 00-.483.321l-.253.606c-.074.177-.18.339-.237.36-.057.02-.348.027-.526-.045l-.608-.244a.572.572 0 00-.57.117l-.253.253a.568.568 0 00-.113.568l.246.599c.072.177.112.368.087.425a1.097 1.097 0 01-.403.347l-.6.257a.573.573 0 00-.32.485v.358c0 .192.145.409.321.483l.599.249c.177.074.34.181.361.24.022.058.03.353-.04.53l-.243.605a.573.573 0 00.117.57l.253.253a.567.567 0 00.568.113l.602-.247c.177-.074.368-.114.423-.09.056.023.268.222.343.398l.26.609c.075.176.293.32.485.32h.358a.567.567 0 00.483-.321l.255-.612c.073-.177.178-.339.233-.36.054-.02.34-.025.517.046l.619.248a.573.573 0 00.57-.117l.253-.253a.566.566 0 00.113-.568l-.253-.615c-.073-.178-.115-.365-.093-.418.022-.052.22-.254.396-.33z"
      fill="none"
      stroke={stroke}
      strokeWidth={0.5291699999999999}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
    />
  </svg>
);

export default Metrics;
